import { STARTUPS_PRO_PRODUCT_ID } from '@src/components/sco/Conversion/intent'
import type { PaywalledActionProps } from '@src/components/sco/PaywalledAction'

/**
 * Gate for comment composers on public content (articles, podcast, videos, courses, events).
 * Any paid plan or an approved advisor profile may post: startups3 `canPostPublicComments`, which
 * the API also enforces. Private threads (task comments) pass `isUnlocked: true`. The upsell sells
 * Startups Pro, the cheapest ladder plan.
 */
export const PUBLIC_COMMENT_GATE: PaywalledActionProps = {
  contentPermission: 'canPostPublicComments',
  intent: 'discussion-join',
  upgradeProductId: STARTUPS_PRO_PRODUCT_ID,
  variant: 'boxed',
}
